import { FeatureFlags } from '../FeatureFlags';
import { ISliceable } from '../models/ISliceable';
import { Module } from '../Module';
import { IGroup } from '../ServerApi/types/IGroup';
import { IUserName } from '../ServerApi/types/IUser';
import { ITypedItem } from '../ServerApi/types/resourceParts';
import { SearchSuggestionsService } from '../services/SearchSuggestionsService';

interface IUserOrGroupSelectorScope extends ng.IScope {
  autoEdit: boolean;
  principalSelected(locals: {principal: ITypedItem}): any;
  userSelected(locals: {user: IUserName}): any;
  groupSelected(locals: {group: IGroup}): any;

  // internal
  nameSearchSuggestions(match: string): ISliceable<ITypedItem>;
  userSearchSuggestions(match: string): ISliceable<IUserName>;
  groupSearchSuggestions(match: string): ISliceable<IGroup>;
  selected: {
    granteeType?: string;
    principal?: ITypedItem;
    user?: IUserName;
    group?: IGroup;
  };
}

Module.instance().directive('tbUserOrGroupSelector', [
  'SearchSuggestionsService',
  (searchSuggestions: SearchSuggestionsService) => {
    return {
      restrict: 'E',
      templateUrl: 'userOrGroupSelector.html',
      replace: true,
      scope: {
        autoEdit: '=',
        principalSelected: '&',
        userSelected: '&', // remove with ff getGroupAndUserNamesEnabled
        groupSelected: '&' // remove with ff getGroupAndUserNamesEnabled
      },
      link: (scope: IUserOrGroupSelectorScope) => {

        if (FeatureFlags.getGroupAndUserNamesEnabled) {

          scope.selected = {
            granteeType: 'principal' // can we get rid of this?
          };
          scope.nameSearchSuggestions = (match: string) => searchSuggestions.principalNames(match);

          scope.$watch('selected.principal', (principal: ITypedItem) => {
            if (principal) {
              scope.selected.principal = null;
              scope.principalSelected({principal: principal});
            }
          });
        }
        else {
          scope.selected = {
            granteeType: 'group' // group is selected by default.
          };
          scope.userSearchSuggestions = (match: string) => searchSuggestions.users(match);
          scope.groupSearchSuggestions = (match: string) => searchSuggestions.groups(match);

          scope.$watch('selected.user', (user: IUserName) => {
            if (user) {
              scope.selected.user = null;
              scope.userSelected({user: user});
            }
          });
          scope.$watch('selected.group', (group: IGroup) => {
            if (group) {
              scope.selected.group = null;
              scope.groupSelected({group: group});
            }
          });

        }

      }
    };
  }
]);
